import React, { useState } from "react";
import HeaderBar from "../HeaderBar/HeaderBar";
import SideBar from "../SideBar/SideBar";
import authStore from "../../store/authStore";

export default function MainLayout({ children }) {
  const [isShowSideBar, setShowSideBar] = useState(true);
  const { showDeleteBox } = authStore();
  const showSideBar = (value) => {
    setShowSideBar(value);
  };
  const user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    return (
      <>
        <HeaderBar setShowSideBar={showSideBar} />

        <SideBar isShowSideBar={isShowSideBar} />
        <main
          className={
            isShowSideBar ? "pageContainer" : "hideSideBarTextContainer"
          }
        >
          {children}
        </main>
        <div className={showDeleteBox ? "showDeleteBox" : ""}></div>
      </>
    );
  } else {
    window.location.href = "/login";
  }
}
